import React, { memo, useCallback, useId } from 'react'

import {
  Checkbox, Icon, InfoOutlined, Tooltip,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'

import { BOOLEAN_FILTER_VALUE, FILTER_NAME } from 'Pods/SearchPage/Shared/Tracking/constants'
import { useTrackFilterSelect } from 'Pods/SearchPage/Shared/Tracking/FilterTracking'
import useTranslate from 'Pods/SearchPage/Shared/useTranslate'
import { setNativeOnly } from 'Pods/SearchPage/Store/actions/fileTypes'
import { useSearchPageStore } from 'Pods/SearchPage/Store/index'

function NativeOnly() {
  const translate = useTranslate()
  const trackFilterSelect = useTrackFilterSelect()

  // The dropdown and the filters drawer can be mounted together, so each copy keeps its own ids.
  const id = `native-only-${useId().replace(/:/g, '')}`
  const hasFileTypes = useSearchPageStore(state => state.fileTypes.length > 0)
  const nativeOnly = useSearchPageStore(state => state.nativeOnly)

  const handleChange = useCallback((isChecked) => {
    if (isChecked) trackFilterSelect(FILTER_NAME.NATIVE_FORMAT, BOOLEAN_FILTER_VALUE)
    setNativeOnly(isChecked)
  }, [trackFilterSelect])

  return (
    <div className="native-only">
      <Checkbox
        id={id}
        name={id}
        className="native-only__checkbox"
        label={translate('search_page.filters.file_format.native_only')}
        isChecked={nativeOnly}
        isDisabled={!hasFileTypes}
        isControlled
        onChange={handleChange}
      />
      <Tooltip
        id={`${id}-tooltip`}
        content={translate('search_page.filters.file_format.native_only_tooltip')}
        place="top"
        containerClass="native-only__info"
      >
        <span className="native-only__tooltip-trigger">
          <Icon svgComponent={InfoOutlined} size="small" color="dark" notSpaced />
        </span>
      </Tooltip>
    </div>
  )
}

export default memo(NativeOnly)
